import { render, staticRenderFns } from "./payDone.vue?vue&type=template&id=179ac8cc&"
import script from "./payDone.vue?vue&type=script&lang=ts&"
export * from "./payDone.vue?vue&type=script&lang=ts&"
import style0 from "./payDone.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports